class FacetFiltersForm extends HTMLElement {
  constructor() {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 500)

    const facetForm = this.querySelector("form")
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this))

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop")
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape)
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener("popstate", onHistoryChange)
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable)
    })
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()
    document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading")

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event)
    })

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }]
        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.renderProductGridContainer(html)
        FacetFiltersForm.runCustomEmptyStateLogic()
        infiniteScrollCollection()
        scrollHorizontalFilters()
        facetsPriceRange()
        setTimeout(() => {
          loadWishlist()
        }, 1000)
      })
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGridContainer(html)
    infiniteScrollCollection()
    scrollHorizontalFilters()
    facetsPriceRange()
    setTimeout(() => {
      loadWishlist()
    }, 1000)
  }

  static renderProductGridContainer(html) {
    const grid = document.getElementById("ProductGridContainer").querySelector("#product-grid").classList

    const new_inner_string = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer")

    if (grid.contains("grid--secondary")) {
      new_inner_string.querySelector(".change-grid")?.classList.add("grid--secondary")
      new_inner_string.querySelector("#product-grid")?.classList.add("grid--secondary")
    }

    const new_inner_html = new_inner_string.innerHTML

    document.getElementById("ProductGridContainer").innerHTML = new_inner_html
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html")

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    )
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false
    }
    const facetsToRender = Array.from(facetDetailsElements)

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML)
    FacetFiltersForm.renderAdditionalElements(parsedHTML)
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets-mobile", ".active-facets-desktop"]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    FacetFiltersForm.toggleActiveFacets(false)
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
      ".mobile-facets__footer",
    ]

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML
    })

    document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents()
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`)
  }

  static getSections() {
    return [
      {
        section: document.querySelector("#ProductGridContainer").dataset.id,
      },
    ]
  }

  static runCustomEmptyStateLogic() {
    const marker = document.getElementById("js-no-products-rendered")
    if (marker) {
      const subIndex = document.getElementById("facets__sub-index")
      if (subIndex) subIndex.textContent = ""
    }
  }

  createSearchParams(form) {
    const formData = new FormData(form)

    const minInput = form.querySelector('input[name="filter.v.price.gte"]')
    const maxInput = form.querySelector('input[name="filter.v.price.lte"]')

    if (minInput && maxInput) {
      const minPrice = parseFloat(minInput.getAttribute("min")) || 0
      const maxPrice = parseFloat(maxInput.getAttribute("max"))
      const valueMinPrice = parseFloat(formData.get("filter.v.price.gte"))
      const valueMaxPrice = parseFloat(formData.get("filter.v.price.lte"))

      if (minPrice === valueMinPrice && maxPrice === valueMaxPrice) {
        formData.delete("filter.v.price.gte")
        formData.delete("filter.v.price.lte")
      } else {
        formData.set("filter.v.price.gte", valueMinPrice)
        formData.set("filter.v.price.lte", valueMaxPrice)
      }
    }

    return new URLSearchParams(formData).toString()
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event)
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const sortFilterForms = document.querySelectorAll("facet-filters-form form")
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(event.target.closest("form"))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = []
      const isMobile = event.target.closest("form").id === "FacetFiltersFormMobile"

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === "FacetSortForm" || form.id === "FacetFiltersForm" || form.id === "FacetSortDrawerForm") {
            forms.push(this.createSearchParams(form))
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form))
        }
      })
      this.onSubmitForm(forms.join("&"), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1)
    FacetFiltersForm.renderPage(url)
  }
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define("facet-filters-form", FacetFiltersForm)
FacetFiltersForm.setListeners()

class PriceRange extends HTMLElement {
  constructor() {
    super()
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    )
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget)
  }

  adjustToValidValues(input) {
    const value = parseFloat(input.value)
    const min = parseFloat(input.getAttribute("min"))
    const max = parseFloat(input.getAttribute("max"))

    if (value < min) input.value = min.toFixed(2)
    if (value > max) input.value = max.toFixed(2)
  }
}

customElements.define("price-range", PriceRange)

class FacetRemove extends HTMLElement {
  constructor() {
    super()
    const facetLink = this.querySelector("a")
    facetLink.setAttribute("role", "button")
    facetLink.addEventListener("click", this.closeFilter.bind(this))
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault()
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event)
    })
  }

  closeFilter(event) {
    event.preventDefault()
    const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form")
    form.onActiveFilterClick(event)
  }
}

customElements.define("facet-remove", FacetRemove)

class ChangeGrid extends HTMLElement {
  constructor() {
    super()

    const buttonChangeGrid = this.querySelector("button")
    buttonChangeGrid.addEventListener("click", this.changeCollectionGrid.bind(this))
  }

  changeCollectionGrid() {
    const grid = this.closest(".shopify-section").querySelector("#product-grid")
    grid.classList.toggle("grid--secondary")
    this.classList.toggle("grid--secondary")
  }
}

customElements.define("change-grid", ChangeGrid)

document.addEventListener("DOMContentLoaded", function () {
  let lastScrollTop = 0
  let scrollTimeout
  let scrollDelay

  const filterElement = document.querySelector(".facets-wrapper")
  if (!filterElement) return

  const filterTop = filterElement.getBoundingClientRect().top + window.scrollY

  window.addEventListener("scroll", function () {
    clearTimeout(scrollDelay)
    scrollDelay = setTimeout(() => {
      if (document.querySelector("#main-collection-filters .menu-opening .mobile-facets__open")) {
        return
      }

      const currentScroll = window.pageYOffset || document.documentElement.scrollTop

      if (currentScroll >= filterTop) {
        if (currentScroll > lastScrollTop) {
          filterElement.classList.add("hide-filters")
        } else {
          filterElement.classList.remove("hide-filters")
        }

        clearTimeout(scrollTimeout)
        scrollTimeout = setTimeout(function () {
          filterElement.classList.remove("hide-filters")
        }, 5000)
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll
    }, 1)
  })
})
